import {
  getHumanResourcesEmployeeDetailAsync,
  getHumanResourcesEmployeeAutocompleteAsync,
  getHumanResourcesPositionsAutocompleteAsync,
  getHumanResourcesDepartmentsAutocompleteAsync,
  getHumanResourcesCompanyAutocompleteAsync,
  saveHumanResourcesEmployeeAsync,
  deleteHumanResourcesEmployeeAsync,
  getHumanResourcesEmployeeTypeListAsync,
} from "State/HumanResources/HumanResourcesReducer";
import {
  getHumanResourceGetEmployee,
  postHumanResourceEmployeesAutocomplete,
  postHumanResourcePositionsAutocomplete,
  getHumanResourceDepartmentsAutocomplete,
  getHumanResourceCompanyAutocomplete,
  postHumanResourceSaveEmployee,
  deleteHumanResourceDeleteEmployee,
  getHumanResourceGetEmployeeTypeList,
} from "Api/Api";
import { call } from "typed-redux-saga";
import { put, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import i18next from "i18next";
import { getResourcePath, Resources } from "Translations/Resources";
import { toast } from "react-toastify";

function* getHumanResourcesEmployeeDetail(
  action: ReturnType<typeof getHumanResourcesEmployeeDetailAsync.request>,
): Generator {
  try {
    const response = yield* call(getHumanResourceGetEmployee, action.payload);
    if (response.status === 200) {
      yield put(getHumanResourcesEmployeeDetailAsync.success(response.json));
    } else {
      yield put(getHumanResourcesEmployeeDetailAsync.failure(new Error()));
    }
  } catch (err) {
    // yield put(getHumanResourcesEmployeeDetailAsync.failure(err));
  }
}
export function* getHumanResourcesEmployeeDetailSaga() {
  yield takeLatest(
    getType(getHumanResourcesEmployeeDetailAsync.request),
    getHumanResourcesEmployeeDetail,
  );
}

function* getHumanResourcesEmployeeAutocomplete(
  action: ReturnType<typeof getHumanResourcesEmployeeAutocompleteAsync.request>,
): Generator {
  try {
    const response = yield* call(
      postHumanResourceEmployeesAutocomplete,
      action.payload,
    );
    if (response.status === 200) {
      yield put(
        getHumanResourcesEmployeeAutocompleteAsync.success(response.json),
      );
    } else {
      yield put(
        getHumanResourcesEmployeeAutocompleteAsync.failure(new Error()),
      );
    }
  } catch (err) {
    // yield put(getHumanResourcesEmployeeAutocompleteAsync.failure(err));
  }
}
export function* getHumanResourcesEmployeeAutocompleteSaga() {
  yield takeLatest(
    getType(getHumanResourcesEmployeeAutocompleteAsync.request),
    getHumanResourcesEmployeeAutocomplete,
  );
}

function* getHumanResourcesPositionsAutocomplete(
  action: ReturnType<
    typeof getHumanResourcesPositionsAutocompleteAsync.request
  >,
): Generator {
  try {
    const response = yield* call(
      postHumanResourcePositionsAutocomplete,
      action.payload,
    );
    if (response.status === 200) {
      yield put(
        getHumanResourcesPositionsAutocompleteAsync.success(response.json),
      );
    } else {
      yield put(
        getHumanResourcesPositionsAutocompleteAsync.failure(new Error()),
      );
    }
  } catch (err) {
    //yield put(getHumanResourcesPositionsAutocompleteAsync.failure(err));
  }
}
export function* getHumanResourcesPositionsAutocompleteSaga() {
  yield takeLatest(
    getType(getHumanResourcesPositionsAutocompleteAsync.request),
    getHumanResourcesPositionsAutocomplete,
  );
}

function* getHumanResourcesDepartmentsAutocomplete(
  action: ReturnType<
    typeof getHumanResourcesDepartmentsAutocompleteAsync.request
  >,
): Generator {
  try {
    const response = yield* call(
      getHumanResourceDepartmentsAutocomplete,
      action.payload,
    );
    if (response.status === 200) {
      yield put(
        getHumanResourcesDepartmentsAutocompleteAsync.success(response.json),
      );
    } else {
      yield put(
        getHumanResourcesDepartmentsAutocompleteAsync.failure(new Error()),
      );
    }
  } catch (err) {
    //yield put(getHumanResourcesDepartmentsAutocompleteAsync.failure(err));
  }
}
export function* getHumanResourcesDepartmentsAutocompleteSaga() {
  yield takeLatest(
    getType(getHumanResourcesDepartmentsAutocompleteAsync.request),
    getHumanResourcesDepartmentsAutocomplete,
  );
}

function* getHumanResourcesCompanyAutocomplete(
  action: ReturnType<typeof getHumanResourcesCompanyAutocompleteAsync.request>,
): Generator {
  try {
    const response = yield* call(
      getHumanResourceCompanyAutocomplete,
      action.payload,
    );
    if (response.status === 200) {
      yield put(
        getHumanResourcesCompanyAutocompleteAsync.success(response.json),
      );
    } else {
      yield put(getHumanResourcesCompanyAutocompleteAsync.failure(new Error()));
    }
  } catch (err) {
    //yield put(getHumanResourcesCompanyAutocompleteAsync.failure(err));
  }
}
export function* getHumanResourcesCompanyAutocompleteSaga() {
  yield takeLatest(
    getType(getHumanResourcesCompanyAutocompleteAsync.request),
    getHumanResourcesCompanyAutocomplete,
  );
}

function* saveHumanResourcesEmployeeDetail(
  action: ReturnType<typeof saveHumanResourcesEmployeeAsync.request>,
): Generator {
  try {
    const response = yield* call(postHumanResourceSaveEmployee, action.payload);

    const showValidation = (): void => {
      toast.error(
        i18next.t(
          response.json.validationErrors && response.json.validationErrors
            ? response.json.validationErrors[0].message
            : getResourcePath(Resources.HumanResources.EmployeeEdit.SaveFail),
        ),
      );
    };

    if (response.status === 200) {
      if (
        response.json.data &&
        response.json.validationErrors &&
        response.json.validationErrors.length === 0
      ) {
        toast.success(
          i18next.t(
            getResourcePath(Resources.HumanResources.EmployeeEdit.SaveSuccess),
          ),
        );
      } else {
        showValidation();
      }
      yield put(saveHumanResourcesEmployeeAsync.success(response.json));
    } else if (response.status === 400) {
      showValidation();
    } else {
      toast.error(
        i18next.t(
          getResourcePath(Resources.HumanResources.EmployeeEdit.SaveFail),
        ),
      );
      yield put(saveHumanResourcesEmployeeAsync.failure(new Error()));
    }
  } catch (err) {
    //yield put(saveHumanResourcesEmployeeAsync.failure(err));
  }
}
export function* saveHumanResourcesEmployeeDetailSaga() {
  yield takeLatest(
    getType(saveHumanResourcesEmployeeAsync.request),
    saveHumanResourcesEmployeeDetail,
  );
}

function* deleteHumanResourcesEmployee(
  action: ReturnType<typeof deleteHumanResourcesEmployeeAsync.request>,
): Generator {
  try {
    const response = yield* call(
      deleteHumanResourceDeleteEmployee,
      action.payload,
    );
    if (response.status === 200) {
      if (response.json.isValid) {
        toast.success(
          i18next.t(
            getResourcePath(
              Resources.HumanResources.Employees.Detail.Delete.Success,
            ),
          ),
        );
      } else {
        toast.error(
          i18next.t(
            response.json.validationErrors
              ? response.json.validationErrors[0].message
              : "Zaměstnance se nezdařilo smazat",
          ),
        );
      }
      yield put(
        deleteHumanResourcesEmployeeAsync.success({
          employeeID: action.payload,
          result: response.json,
        }),
      );
    } else {
      toast.error(
        i18next.t(
          getResourcePath(
            Resources.HumanResources.Employees.Detail.Delete.Fail,
          ),
        ),
      );
      yield put(deleteHumanResourcesEmployeeAsync.failure(new Error()));
    }
  } catch (err) {
    //yield put(deleteHumanResourcesEmployeeAsync.failure(err));
  }
}
export function* deleteHumanResourcesEmployeeSaga() {
  yield takeLatest(
    getType(deleteHumanResourcesEmployeeAsync.request),
    deleteHumanResourcesEmployee,
  );
}

function* getHumanResourcesEmployeeTypes(
  action: ReturnType<typeof getHumanResourcesEmployeeTypeListAsync.request>,
): Generator {
  try {
    const response = yield* call(getHumanResourceGetEmployeeTypeList);
    if (response.status === 200) {
      yield put(getHumanResourcesEmployeeTypeListAsync.success(response.json));
    } else {
      yield put(getHumanResourcesEmployeeTypeListAsync.failure(new Error()));
    }
  } catch (err) {
    // yield put(getHumanResourcesEmployeeAutocompleteAsync.failure(err));
  }
}
export function* getHumanResourcesEmployeeTypesSaga() {
  yield takeLatest(
    getType(getHumanResourcesEmployeeTypeListAsync.request),
    getHumanResourcesEmployeeTypes,
  );
}
